import type { NftMiniature } from "@anaconda/core/nft/types"
import type { Action, Atom } from "@reatom/core"
import { createScope } from "bunshi"

export interface ReatomNftsSelectionScopeState {
  selectedNftsAtom: Atom<NftMiniature[]>
  toggleNftSelectionAction: Action<[NftMiniature], void>
  selectionAvailable: boolean
}

/**
 * Reatom-based scope for NFT selection state
 * Provides atoms and actions for managing NFT selection across components
 */
export const NftsSelectionScopeReatom =
  createScope<ReatomNftsSelectionScopeState>({
    // Placeholder values - will be provided by ScopeProvider
    selectedNftsAtom: undefined as unknown as Atom<NftMiniature[]>,
    toggleNftSelectionAction: undefined as unknown as Action<
      [NftMiniature],
      void
    >,
    selectionAvailable: false,
  })
